import { makeStyles } from "tss-react/mui"
import { faTrashCan } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton, Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { groupResourcesForRendering } from "./helpers"
import { ResourceItem } from "../../createOrderTypes"

type StyleProps = Readonly<{
    isRedIcon: boolean
}>

const useStyles = makeStyles<StyleProps>()((theme, { isRedIcon }) => ({
    trashButton: {
        padding: 0,
        color: isRedIcon ? theme.palette.tailwind.red[400] : theme.palette.tailwind.slate[400],
    },
}))

type ResourcesListInfoProps = Readonly<{
    resourcesList: ResourceItem[]
    handleDeleteResource?: (id: number) => void
    showResourcesType?: boolean
    isRedIcon?: boolean
}>

export function ResourcesListInfo({
    resourcesList,
    handleDeleteResource,
    showResourcesType = true,
    isRedIcon = true,
}: ResourcesListInfoProps) {
    const { classes } = useStyles({ isRedIcon })

    const groupedResourcesList = groupResourcesForRendering(resourcesList)

    return (
        <>
            {groupedResourcesList.map(({ typeId, typeName, resources }, index) => (
                <Stack gap=".75rem" key={`${typeId}_${index}`}>
                    {showResourcesType && (
                        <LocalizedStrict id={typeName}>
                            <Typography variant="subtitle1">{typeName}</Typography>
                        </LocalizedStrict>
                    )}

                    {resources.map((res) => (
                        <Stack
                            alignItems="center"
                            flexDirection="row"
                            gap="1rem"
                            justifyContent="space-between"
                            key={res.id}
                        >
                            <Typography variant="body1">{res.title}</Typography>
                            {handleDeleteResource && (
                                <IconButton
                                    onClick={() => handleDeleteResource(+res.id)}
                                    className={classes.trashButton}
                                >
                                    <FontAwesomeIcon icon={faTrashCan} size="xs" />
                                </IconButton>
                            )}
                        </Stack>
                    ))}
                </Stack>
            ))}
        </>
    )
}
